import type { IContact } from "@bbj-types/contact";
import { Typography } from "@mui/material";
import { formatPhoneNumber } from "@root/utils/phoneLib";
import { useMemo } from "react";

interface IContactInfoProps {
  contact: IContact;
  disableDescription?: boolean;
}

export const ContactInfo = ({ contact, disableDescription }: IContactInfoProps) => {
  const boldText = useMemo(() => {
    const info: string[] = [];
    if (contact.firstName || contact.lastName) {
      info.push(`${contact.firstName} ${contact.lastName}`.trim());
    }
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    if (contact.place && (contact.place.placeLabel || contact.place.postalCodes?.[0] || contact.place.placeKind)) {
      if (contact.place.placeLabel && contact.place.postalCodes?.[0]) {
        info.push(`${contact.place.placeLabel} (${contact.place.postalCodes[0]})`);
      } else if (contact.place.placeLabel) {
        info.push(contact.place.placeLabel);
      } else if (contact.place.postalCodes?.[0]) {
        info.push(contact.place.postalCodes[0]);
      } else {
        info.push(contact.place.placeLabel);
      }
    }
    return info.join(" • ");
  }, [contact]);
  return (
    <>
      <Typography
        variant="body1"
        sx={{
          lineHeight: 1.5,
          color: "black !important",
          paddingBottom: "8px !important",
          paddingTop: "8px !important",
        }}
      >
        {boldText && (
          <Typography variant="body1SemiBold" sx={{ p: "0 !important" }}>
            {`${boldText} • `}
          </Typography>
        )}
        {contact.job && contact.job.length > 0 && `${contact.job} • `}
        {contact.email && `${contact.email}${contact.phone ? " • " : ""}`}
        {contact.phone && `${formatPhoneNumber(contact.phone)}`}
      </Typography>
      {contact.description && !disableDescription && (
        <Typography
          variant="body1"
          sx={{
            lineHeight: 1,
            color: "black !important",
            paddingBottom: "8px !important",
          }}
        >
          {contact.description}
        </Typography>
      )}
    </>
  );
};
